import { render, staticRenderFns } from "./TransferAccounts.vue?vue&type=template&id=a295d8f8&scoped=true&"
import script from "./TransferAccounts.vue?vue&type=script&lang=js&"
export * from "./TransferAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccounts.vue?vue&type=style&index=0&id=a295d8f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a295d8f8",
  null
  
)

export default component.exports